class HelperCollection extends App.Collections.BaseCollection {
    url = 'Helper';
    model = App.Models.Helper;
}

App.Collections.Helpers = HelperCollection;
